export class InvoiceAdjustments {
  public constructor(init?: Partial<InvoiceAdjustments>) {
    Object.assign(this, init);
  }
  primaryKey: string;
  lotNumber: string;
  generateBillingLineItemId: string;
  manualInvoiceId: string;
  customerName: string;
  lineItemName: string;
  description: string;
  adjustment: number;
  rate: number;
  tax: number;
  totalAmount: number;
  reason: string;
  billingDetailID: number;
  isTaxActive: boolean;
  taxPercentages: string;
  calcedAdjustmentAmount: number;
  netAmountAfterAdjustment: number;
  gbOriginalBillingDetailId: number;
}
